import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@material-ui/core';
import GenericAccordion from '../../../../../../common/components/presentation/genericAccordion/GenericAccordion';
import accessoryPacksSectionStyles from './AccessoryPacksSectionStyles';
import AccessoryPackItem from '../accessoryPackItem/AccessoryPackItem';
import useAccordionStoreState from '../../../../../react/useAccordionStoreState';
import IExtendedAccessoryPack from '../../../../../model/accessories/IExtendedAccessoryPack';
import { CustomiseSections } from '../../../../../../common/enum/CustomiseSections';
import SectionStatesWrapper, {
  ISectionStatesProps,
} from '../../../../../../common/components/configuratorStates/SectionStatesWrapper';
import Translation from '../../../../../../common/components/translation/Translation';

export interface IAccessoryPacksSectionProps extends ISectionStatesProps {
  packs: IExtendedAccessoryPack[];
  selectedPacks: string[];
  onSelect: (id: string) => void;
}

const AccessoryPacksSection: FunctionComponent<IAccessoryPacksSectionProps> = ({
  packs,
  selectedPacks,
  onSelect,
  error,
  loading,
}) => {
  const styles = accessoryPacksSectionStyles();
  const { expanded, setExpanded } = useAccordionStoreState(CustomiseSections.PACKS);
  const lowerCasedSelectedPacks = selectedPacks?.map(pack => pack.toLowerCase());

  const renderOptions = () => {
    return (
      <Box className={styles.container}>
        <Typography component="span" variant="caption" className={styles.subtitle}>
          <Translation id="spc.customise.accessoryPacks.subtitle" />
        </Typography>
        {packs.map(pack => (
          <Box mb={3} key={pack.id}>
            <AccessoryPackItem
              id={pack.id}
              name={pack.name}
              prices={pack.prices}
              accessories={pack.accessories}
              selected={lowerCasedSelectedPacks?.includes(pack.id.toLowerCase())}
              onClick={onSelect}
              onToggle={onSelect}
            />
          </Box>
        ))}
      </Box>
    );
  };

  return (
    <GenericAccordion
      expanded={expanded}
      setExpanded={setExpanded}
      summary={
        <Typography component="h3" variant="sectionTitle">
          <Translation id="spc.customise.configuratorSummary.options" />
        </Typography>
      }
      details={
        <SectionStatesWrapper loading={loading || !packs?.length} error={error}>
          {renderOptions()}
        </SectionStatesWrapper>
      }
    />
  );
};

export default AccessoryPacksSection;
